'use client';

import useTranslation from 'next-translate/useTranslation';
import { TaxonomyType, defaultLanguage } from '@stereoagency/constants';
import { InfoCard } from '@stereoagency/ui';
import { createDocumentURL, findInKeyArray } from '@/utils';
import { relatedProjectsQuery } from './groupOrPlatformSubqueries';

type Props = {
  project: (typeof relatedProjectsQuery)[1][number];
};

export default function GroupOrPlatformProjectRow({ project }: Props) {
  const { t, lang } = useTranslation();

  const title = project.title
    ? findInKeyArray(project.title, [lang, defaultLanguage.id])
    : null;

  const taxonomy = project.taxonomies?.find(
    (tax) => tax.type === TaxonomyType.DISEASE_AREA
  );
  const label = taxonomy?.name
    ? findInKeyArray(taxonomy.name, [lang, defaultLanguage.id])
    : null;

  if (!title?.value || !project.slug?.current) {
    return null;
  }

  const href = createDocumentURL(lang, 'researchProject', project.slug.current);

  return (
    <InfoCard
      variant="tight"
      label={label?.value}
      title={title?.value}
      action={{ href }}
      callToActions={[
        {
          href,
          label: t('global:read-more')
        }
      ]}
    />
  );
}
